import React, { useState } from 'react';
import { connect } from 'react-redux';
import { FormControl, InputLabel } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { getSitesLld, selectSiteLld } from '../../store/sitesLld/actions';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

const LldSitesSelect = (props) => {
  const [selected, setSelected] = useState(props.sitesLld.selected);

  if (props.authUser && props.roles) {
    if (!props.sitesLld.content && !props.sitesLld.error && !props.sitesLld.pending) {
      props.getSitesLld(props.authUser.ma, props.roles[props.authUser.uid]);
    }
  }

  const handleChange = (event) => {
    props.selectSiteLld(event.target.value);
    setSelected(event.target.value);
  };

  const items = props.sitesLld.content || [];
  return (
    <Grid item xs={12} sm={12} md={4}>
      <FormControl
        style={{
          marginLeft: '8px',
          marginRight: '8px',
          marginTop: 0,
          marginBottom: 0,
        }}
      >
        <InputLabel style={{ width: '200px' }} htmlFor="type">{'Site'}</InputLabel>
        <Select
          value={selected}
          onChange={handleChange}
          id="sites-lld-select"
          name="sites-lld-select"
          style={{ width: '300px' }}
        >
          {items.map(elem => {
            return <MenuItem value={elem.id} key={`lld-site-${elem.id}`}>
              {elem.name}
            </MenuItem>;
          })}
        </Select>
      </FormControl>
    </Grid>
  );
};

const mapStateToProps = state => (
  {
    roles: state.roles.content,
    sitesLld: state.sitesLld,
    authUser: state.users.authUser,
  }
);

export default connect(
  mapStateToProps,
  {
    getSitesLld,
    selectSiteLld,
  },
)(LldSitesSelect);



// WEBPACK FOOTER //
// ./src/components/LldSitesSelect/LldSitesSelect.jsx